import { createFileRoute } from '@tanstack/react-router';
import { AuthCallback } from '@/features/auth/auth-callback';

// El nombre de archivo con punto (auth.callback.tsx) se mapea a la URL
// /auth/callback en el routing file-based de TanStack Router.
export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
});
